import React, {Component} from 'react';


class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {
        const loading = {
            background: '#060606',
            color: '#666',
            position: 'fixed',
            height: '100%',
            width: '100%',
            zIndex: '999999',
            top: '0',
            left: '0',
            float: 'left',
            textAlign: 'center',
            paddingTop: '12%',
        };
        return (
            <div style={loading}>
                <img src="/p3x-exchange/images/loading.gif" alt="Loading spinner."/>
            </div>

        );
    }
}

export default Loading;